import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IOsaExecucaoPapelTrabalho } from '../../../../../models/osa-execucao-papel-trabalho.model';
import { OsaExecucaoPapelTrabalhoService } from '../../../../../services/osa-execucao-papel-trabalho.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-osa-execucao-aba-papaeis-imprimir',
  templateUrl: './osa-execucao-aba-papaeis-imprimir.component.html',
  styleUrls: ['./osa-execucao-aba-papaeis-imprimir.component.scss']
})
export class OsaExecucaoAbaPapaeisImprimirComponent implements OnInit {

  osaExecucaoId: number;

  model: IOsaExecucaoPapelTrabalho[] = [];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private osaExecucaoPapelTrabalhoService: OsaExecucaoPapelTrabalhoService,
  ) {
    this.osaExecucaoId = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.carregaPapeisTrabalho();
  }

  carregaPapeisTrabalho() {
    this.osaExecucaoPapelTrabalhoService
      .obterPorExecucao(this.osaExecucaoId)
      .then((res) => {
        this.model = res.dados as IOsaExecucaoPapelTrabalho[];
      })
  }

  getSigla(item: IOsaExecucaoPapelTrabalho) {
    return item.sigla + "-" + (item.posicao).toString().padStart(2, "0");
  }

  getSituacao(item: IOsaExecucaoPapelTrabalho) {
    return !item.situacaoNome ? "" : "(" + item.situacaoNome + ")";
  }

  public cancelar() {
    this.router.navigate(['/osa-execucao']);
    //this.router.navigate([`/osa-execucao/${this.idPlanejamento}/planejar`], { state: { aba: 8 }})
  }

  public print() {
    window.print();
  }

  exibeJustificativa(item: IOsaExecucaoPapelTrabalho) {
    if (item.idTipoAceitavel != 2 && (item.arquivos == null || item.arquivos.length == 0)) {
      return true;
    }
    else if (item.idTipoAceitavel == 2 && this.isValidUrl(item.link) == false) {
      return true;
    }

    return false;
  }

  isValidUrl(value: string): boolean {
    const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,}))(:\d+)?(\/[^\s]*)?$/;
    return pattern.test(value);
  }

}
